export default __webpack_public_path__ + "static/media/emailIcon.7093dbd0.svg";